import Markdown from 'react-markdown';

const TextAreaLarge = (props) => {
    const { text, styleRules } = props;
    return(
        <div className={styleRules.mod?`text_area_large ${styleRules.mod}`:'text_area_large'}>
            <Markdown>
                { text }
            </Markdown>
        </div>)
}

export default TextAreaLarge;